import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchRecomendationSku } from './actions'
import { Showcase } from '../../Showcase'
import { Products } from './reducer'
import { RecomendationCardContainer } from '../../Availability'
import ReactPlaceholder from 'react-placeholder'
import CardPlaceholder from 'loyal-react'

class ProductRecomendationSkuContainer extends Component {
  componentDidMount () {
    if (!this.props.isloading) {
      this.props.fetchRecomendationSku(this.props.productId, 'io')
    }
  }

  render () {
    return (
      <div className='bx-showcase pos-relative'>
        {this.props.products.length > 0 && (
          <Showcase
            title={this.props.title}
            titleMobile={this.props.titleMobile}
            searchPage='/search-Page'
          >
            {this.props.products.map(p => (
              <ReactPlaceholder
                ready={!this.props.isloading}
                customPlaceholder={<CardPlaceholder />}
                key={p.sku}
              >
                <RecomendationCardContainer {...p} key={p.sku} />
              </ReactPlaceholder>
            ))}
          </Showcase>
        )}
      </div>
    )
  }
}

ProductRecomendationSkuContainer.propTypes = {
  fetchRecomendationSku: PropTypes.func,
  title: PropTypes.string,
  titleMobile: PropTypes.string,
  products: PropTypes.array,
  isloading: PropTypes.bool,
  productId: PropTypes.string
}

const mapStateToProps = ({ productRecomendation }) => ({
  ...Products(productRecomendation)
})

const mapDispatchToProps = dispatch => ({
  fetchRecomendationSku: (productId, identifier) =>
    dispatch(fetchRecomendationSku(productId, identifier))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductRecomendationSkuContainer)



// WEBPACK FOOTER //
// ./src/features/Suggestion/ProductRecomendation/ProductRecomendationSkuContainer.js